import { useEffect, useRef, useState } from "react"
import { useLocation } from "react-router-dom"
import { useManagedContext } from "../../components/hooks"
import { ServerRequest } from "../../utils/apiweb"
import { ALERT_TYPE, REQUEST_METHOD, ShowToastMessage } from '@laramie/ui';
import { APIS } from "../../config/apis"
import { SectionHeading, TableCustom, WrapperAdvancedSearch } from "../../components/common"
import { onRequestError, onRequestNoSuccess } from "../../utils/requests"
import { getDateToString, getFormatNumber, truncateTime } from "../../utils/convert"
import { useReporte } from "../../components/hooks/useReporte"
import { OpenObjectURL } from "../../utils/helpers"
import DevolucionRendicionRegistroContableGridModal from "../../components/controls/DevolucionRendicionRegistroContableGridModal"

const initItem = {
    id: 0
}

const DevolucionRendicionRegistroContableHistorialView = () => {
    const { setIsLoading } = useManagedContext()
    const location = useLocation()

    const searchRef = useRef()

    const [lotes, setLotes] = useState([])
    const [editItem, setEditItem] = useState(initItem)
    const [showDetalle, setShowDetalle] = useState(false)
    const [pathArchivoRegistroContable, setPathArchivoRegistroContable] = useState(null)
    const [bufferArchivoRegistroContable, setBufferArchivoRegistroContable] = useState(null)

    useEffect(() => SearchLotes(), [])

    useEffect(() => {
        if (bufferArchivoRegistroContable) {
            OpenObjectURL(pathArchivoRegistroContable??"ArchivoRegistroContable.txt", bufferArchivoRegistroContable);
            setPathArchivoRegistroContable(null)
            setBufferArchivoRegistroContable(null)
        }
    }, [bufferArchivoRegistroContable])

    const [ generateReporte, ] = useReporte({
        callback: (reporte, buffer, message) => {
            if (buffer) {
                if (reporte === "DevolucionRegistroContable") {
                    setBufferArchivoRegistroContable(buffer);
                }
            }
            else {
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message)
            }
        },
        mode: 'blob'
    })

    const filterData = data => {
        const { numeroLote, fechaProcesoDesde,  fechaProcesoHasta} = searchRef.current.filters

        let filtered = [...data]

        if (numeroLote !== '') filtered = filtered.filter(item => item.numeroLote.indexOf(numeroLote) >= 0)
        if (fechaProcesoDesde) filtered = filtered.filter(item => truncateTime(item.fechaProceso).getTime() >= truncateTime(fechaProcesoDesde).getTime())
        if (fechaProcesoHasta) filtered = filtered.filter(item => truncateTime(item.fechaProceso).getTime() <= truncateTime(fechaProcesoHasta).getTime())

        return filtered
    }

    const SearchLotes = () => {
        setIsLoading(true)

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.DEVOLUCION_REGISTRO_CONTABLE_LOTE,
            null,
            null,
            res => res.json().then(data => {
                data.forEach(row => {
                    if (row.fechaLote) row.fechaLote = new Date(row.fechaLote);
                    if (row.fechaProceso) row.fechaProceso = new Date(row.fechaProceso);
                })
                data.sort((a,b) => b.id - a.id)
                setLotes(filterData(data))
                setIsLoading(false)
            }),
            res => {
                onRequestNoSuccess(res)
                setIsLoading(false)
            },
            err => {
                onRequestError(err)
                setIsLoading(false)
            },
        )
    }

    const emitirArchivoRegistroContable = (id) => {
        const paramsReporte = {
            idDevolucionRegistroContableLote: id
        }
        generateReporte("DevolucionRegistroContable", paramsReporte);
    }

    const avmr = {
        onView: (item) => {
            setEditItem(item)
            setShowDetalle(true)
        },
        customActions: [
            {
                icon: 'download',
                title: 'Descargar archivo contable',
                onClick: (item) => {
                    setPathArchivoRegistroContable(item.pathArchivoRegistroContable)
                    emitirArchivoRegistroContable(item.id)
                },
                requiresEdit: true
            }
        ],
    }

    const onModalCancel = () => {
        setShowDetalle(false)
        setEditItem(initItem)
    }


    return <>
        <SectionHeading titles={[{ title: 'Devoluciones' }, { title: 'Historial de rendición a contaduría' }]} />

        <section className='section-accordion'>
            <WrapperAdvancedSearch
                ref={searchRef}
                filters={[
                    { title: 'N° lote', field: 'numeroLote', type: 'string', size: 4, searchOnEnter: true, presetValue: location.state?.numeroLote },
                    { title: 'Fecha proceso desde', field: 'fechaProcesoDesde', type: 'date', size: 4 },
                    { title: 'Fecha proceso hasta', field: 'fechaProcesoHasta', type: 'date', size: 4, minValueField: 'fechaProcesoDesde' },
                ]}
                onSearch={SearchLotes}
            />

            <TableCustom
                className={'TableCustomBase m-top-20'}
                data={lotes}
                avmr={avmr}
                columns={[
                    { Header: 'N° lote', accessor: 'numeroLote', width: '23%', },
                    { Header: 'Fecha lote', accessor: 'fechaLote', Cell: (data) => getDateToString(data.value), width: '11%'},
                    { Header: 'Fecha proceso', accessor: 'fechaProceso', Cell: (data) => getDateToString(data.value, true), width: '11%'},
                    { Header: 'Fecha confirmación', accessor: 'fechaConfirmacion', Cell: (data) => getDateToString(data.value, true), width: '12%' },
                    { Header: 'Registros', accessor: 'casos', Cell: (data) => getFormatNumber(data.value, 0), width: '9%', alignCell: 'right' },
                    { Header: 'Importe total', accessor: 'importeTotal', Cell: (data) => getFormatNumber(data.value, 2), width: '17%', alignCell: 'right' },
                    { Header: 'Archivo contable', accessor: 'pathArchivoRegistroContable', width: '17%', }
                ]}
            />

            {showDetalle && (
                <DevolucionRendicionRegistroContableGridModal
                    idDevolucionRegistroContableLote={editItem.id}
                    onCancel={onModalCancel}
                />
            )}

        </section>
    </>
}

export default DevolucionRendicionRegistroContableHistorialView
